import React from 'react';
import useSheet from 'app/jss';
import colorUtils from 'color';

type Props = {
  classes: Object,
  subText?: string,
  title?: string,
  children?: any,
};

const defaultProps = {
  subText: '',
  title: '',
  children: undefined,
};

function CardContentMessage({
  classes,
  subText,
  children,
  title,
}: Props) {
  return (
    <div className={classes.cardContentMessage}>
      <span className={classes.title}>{title}</span>
      <span className={classes.subText}>
        {children || subText}
      </span>
    </div>
  );
}

CardContentMessage.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    cardContentMessage: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colorUtils(theme.color.white).darken(0.05).hex(),
      textAlign: 'center',
      flexGrow: 1,
      position: 'relative',
      overflow: 'hidden',
      fontWeight: 600,
      padding: theme.spacing.default,
    },
    title: {
      color: theme.color.basis2,
      fontSize: theme.fontSize.large,
    },
    subText: {
      marginTop: '5px',
      color: theme.color.basis3,
      lineHeight: '25px',
    },
  };
}

export default useSheet(applyStyles)(CardContentMessage);
